<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo.jpg" alt="logo图"> -->
      <!-- <img class="weixin_log" src="@/assets/img/weixin1.png" alt="二维码图"> -->
    </div>
    <p class="title">福建茂荣睿智信息科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址:福建省泉州市鲤城区临江街道幸福社区义全街105号金运大厦8楼801室</span>
      <span><br />电话：0595-22859797</span>
    </p>
    <p class="email_wx">
      <span>邮箱：mrruizhi@126.com</span>
      <span>公司公众号：fj_mrrz</span>
    </p>
    <p class="copy"> &copy; 2023 - 2024 福建茂荣睿智信息科技有限公司版权所有
      <a href="https://beian.miit.gov.cn/" target="_blank">
        <span class="copy">闽ICP备17008798号</span>
      </a>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #4877c5;
  background: #003894;
  overflow: hidden;
  text-align: center;
}

.container-fluid .weixin_log {
  width: 160px;
  height: 150px;
  position: absolute;
  left: -26%;
  top: 11px;
}

.logo {
  position: relative;
  top: 10px;
  left: 47%;
  right: 0;
  margin-bottom: 20px;

}

.title {
  color: #FFFFFF;
  font-size: 24px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #FFFFFF;
  font-size: 14px;
  margin: 10px 0;
  margin-bottom: 0px;
}

.email_wx {
  color: #FFFFFF;
  font-size: 14px;
  margin-bottom: 0px;
}

.copy {
  color: #FFFFFF;
  font-size: 14px;
  margin: 0px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 0px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue